import React, { useState } from 'react';
import { Form, Input, InputNumber, Button, Alert } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

interface OrderLookupStepProps {
  initialOrderNumber?: string;
  initialTotal?: string;
  onSearch: (orderNumber: number, total: number) => void;
  loading: boolean;
  error?: string;
}

const OrderLookupStep: React.FC<OrderLookupStepProps> = ({
  initialOrderNumber,
  initialTotal,
  onSearch,
  loading,
  error,
}) => {
  const [orderNumber, setOrderNumber] = useState(initialOrderNumber || '');
  const [total, setTotal] = useState<number | null>(
    initialTotal ? parseFloat(initialTotal) : null
  );

  const handleSearch = () => {
    const num = parseInt(orderNumber, 10);
    if (num > 0 && total && total > 0) {
      onSearch(num, total);
    }
  };

  return (
    <div>
      <Form layout="vertical" size="large">
        <Form.Item label="Número de orden">
          <Input
            placeholder="Ingresa tu número de orden"
            value={orderNumber}
            onChange={(e) => setOrderNumber(e.target.value.replace(/\D/g, ''))}
            onPressEnter={handleSearch}
            maxLength={10}
            style={{ fontSize: 18, textAlign: 'center' }}
          />
        </Form.Item>

        <Form.Item
          label="Total de tu cuenta"
          extra="Ingresa el total exacto que aparece en tu ticket"
        >
          <InputNumber
            placeholder="Ej: 1256.50"
            value={total}
            onChange={(value) => setTotal(value)}
            min={0.01}
            precision={2}
            prefix="$"
            style={{ width: '100%', fontSize: 18 }}
            controls={false}
          />
        </Form.Item>

        {error && (
          <Alert
            type="error"
            message={error}
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Button
          type="primary"
          block
          size="large"
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={loading}
          disabled={!orderNumber || parseInt(orderNumber, 10) <= 0 || !total || total <= 0}
          style={{ backgroundColor: 'var(--color-primary)', borderColor: 'var(--color-primary)' }}
        >
          Buscar orden
        </Button>
      </Form>
    </div>
  );
};

export default OrderLookupStep;
